import { render, staticRenderFns } from "./HrSalaryRankGrant.vue?vue&type=template&id=21af2d60&scoped=true&"
import script from "./HrSalaryRankGrant.vue?vue&type=script&lang=js&"
export * from "./HrSalaryRankGrant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21af2d60",
  null
  
)

export default component.exports